import { type CountryCode } from '@constants'
import { cartStoreMap, type PlatformType } from './store-map'

export const useFpB2bMerchantService = (campaignId: number, platform: PlatformType) => {
  const { useCartStore, cartDefaultValues } = cartStoreMap[platform]
  const [cartValues, setCartValues] = useCartStore(campaignId)

  const setMerchant = (index: number, billingFirstName: string, billingCountry: CountryCode) => {
    setCartValues(state => ({
      ...state,
      merchant: {
        ...state.merchant,
        index,
        billingFirstName,
        billingCountry,
      },
    }))
  }

  const clearMerchant = () => {
    setCartValues(state => ({
      ...state,
      merchant: cartDefaultValues.merchant,
    }))
  }

  return {
    setMerchant,
    clearMerchant,
    merchant: cartValues.merchant,
  }
}
